import { Injectable } from '@angular/core';
import { StorageKeys } from 'src/app/shared/enums/storage.enum';
import { StorageService } from 'src/app/shared/services/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private storageService: StorageService) {}

  isTokenValid(): boolean {
    const token = this.storageService.get(StorageKeys.AccessToken);

    if (!token) return false;

    try {
      return token.accessToken.split('.').length === 3;
    } catch (e) {
      return false;
    }
  }

  decodedToken(): any {
    const token = this.storageService.get(StorageKeys.AccessToken);

    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.accessToken.split('.')[1]));
      return payload;
    } catch (e) {
      return {};
    }
  }
}
